import { GetterTree } from 'vuex';
import { RootState } from '@/store/index';
import { FormState } from '@/store/modules/form/index';
import { FormHeaders } from '@/models/Form.model';
import { EmployerDetails } from '@/models/form/EmployerDetails.model';
import { City } from '@/models/form/PersonalDetails.model';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import {
  CITIES,
  CREATE_FORM_ERRORS,
  CREATE_FORM_LOADING,
  EDIT_FORM_ERRORS,
  EMPLOYER_DETAILS,
  FORM101_DATA,
  FORM101_ID,
  FORM101_META_DATA,
  FORM_ERRORS,
  FORM_ERRORS_OPEN,
  FORM_ERRORS_SHOW,
  FORM_HEADERS,
  FORM_LOADING_MODE,
  FORM_READ_ONLY_MODE,
  FORM_REJECTED_REASON,
  FORM_SUCCESS_DIALOG,
  NO_PDF_ERROR,
  NO_PDF_ERRORS,
  OPEN_APPROVE_FORM_DIALOG,
  OPEN_CHOOSE_FORM_OFFICE_MODAL,
  OPEN_CONFIRM_FORM_DIALOG,
  OPEN_FORM_101_CHANGES_DIALOG,
  OPEN_FORM_STATUS_HISTORY_DIALOG,
  OPEN_REJECT_FORM_DIALOG,
  OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME,
  SETTLEMENTS,
  SUBMIT_FORM_ERRORS,
  TOOLTIP_ID,
  WIZARD_HEADER_TITLE,
  OPEN_DELETE_FORM_MODAL,
  SKIP_SAVE_BEFORE_LEAVE_WIZARD_MODAL,
  DELETE_FORM_ERRORS,
  OPEN_CHANGES_NOTIFICATION_MODAL,
} from '@/types/form.types';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import { WizardFormErrors } from '@/models/form/WizardFormError';

export const getters: GetterTree<FormState, RootState> = {

  [FORM_HEADERS](state): FormHeaders {
    return state.formHeaders;
  },

  // get form object details
  [FORM101_DATA](state): Form101DataModel {
    return state.form101Data;
  },

  [FORM101_META_DATA](state): Form101MetaData {
    return state.form101MetaData;
  },

  [FORM_READ_ONLY_MODE](state): boolean {
    return state.formReadOnlyMode;
  },

  // get form employer details
  [EMPLOYER_DETAILS](state): EmployerDetails {
    return state.employerDetails;
  },

  [FORM101_ID](state): number | null {
    return state.formId;
  },

  [CREATE_FORM_ERRORS](state): string[] {
    return state.createFormErrors;
  },

  [EDIT_FORM_ERRORS](state): string[] {
    return state.editFormErrors;
  },

  [NO_PDF_ERROR](state): boolean {
    return state.noPdfError;
  },

  [NO_PDF_ERRORS](state): string[] {
    return state.noPdfErrors;
  },

  // get cities for the select field of cities
  [CITIES](state): City[] {
    return state.cities;
  },

  [SETTLEMENTS](state): City[] {
    return state.settlements;
  },

  [EMPLOYER_DETAILS](state): EmployerDetails {
    return state.employerDetails;
  },

  [CITIES](state): City[] {
    return state.cities;
  },

  [FORM_LOADING_MODE](state): boolean {
    return state.formLoadingMode;
  },

  [FORM_SUCCESS_DIALOG](state): boolean {
    return state.formSuccessDialog;
  },

  [OPEN_CONFIRM_FORM_DIALOG](state): boolean {
    return state.openConfirmFormDialog;
  },

  [FORM_ERRORS](state): WizardFormErrors | null {
    return state.formErrors;
  },

  [SUBMIT_FORM_ERRORS](state): string[] {
    return state.submitFormErrors;
  },

  [WIZARD_HEADER_TITLE](state): string {
    return state.wizardHeaderTitle;
  },

  [TOOLTIP_ID](state): string {
    return state.tooltipId;
  },

  [FORM_ERRORS_OPEN](state): boolean {
    return state.formErrorsOpen;
  },

  [FORM_ERRORS_SHOW](state): boolean {
    return state.formErrorsShow;
  },

  [OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL](state): boolean {
    return state.openSaveBeforeLeaveWizardModal;
  },

  [SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME](state): string {
    return state.saveBeforeLeaveWizardRouteName;
  },

  [SKIP_SAVE_BEFORE_LEAVE_WIZARD_MODAL](state): boolean {
    return state.skipSaveBeforeLeaveWizardModal;
  },

  [DELETE_FORM_ERRORS](state): string[] {
    return state.deleteFormErrors;
  },

  [FORM_REJECTED_REASON](state): string {
    return state.formRejectedReason;
  },

  [OPEN_APPROVE_FORM_DIALOG](state): boolean {
    return state.openApproveFormDialog;
  },

  [OPEN_REJECT_FORM_DIALOG](state): boolean {
    return state.openRejectFormDialog;
  },

  [OPEN_FORM_STATUS_HISTORY_DIALOG](state): boolean {
    return state.openFormStatusHistoryDialog;
  },

  [OPEN_FORM_101_CHANGES_DIALOG](state): boolean {
    return state.openForm101ChangesDialog;
  },

  [OPEN_CHOOSE_FORM_OFFICE_MODAL](state): boolean {
    return state.openChooseFormOfficeModal;
  },

  [CREATE_FORM_LOADING](state): boolean {
    return state.createFormLoading;
  },
  [OPEN_DELETE_FORM_MODAL](state): boolean {
    return state.openDeleteFormModal;
  },

  [OPEN_CHANGES_NOTIFICATION_MODAL](state): boolean {
    return state.openChangesNotificationModal;
  },
};
